module.exports = __webpack_public_path__ + "img/Fachberater.a81eaca7.svg";